import { gql } from "../gql";
import "./fragments";

export const SERVICES_QUERY = gql(`
  query Services($salonId: ID!) {
    services(salonId: $salonId) {
      ...ServiceDetail @unmask
    }
  }
`);

export const SERVICE_CATEGORIES_QUERY = gql(`
  query ServiceCategories($salonId: ID!) {
    serviceCategories(salonId: $salonId) {
      ...ServiceCategory @unmask
      catalogId
      createdAt
      updatedAt
    }
  }
`);

export const SERVICE_QUERY = gql(`
  query Service($salonId: ID!, $serviceId: ID!) {
    service(salonId: $salonId, serviceId: $serviceId) {
      ...ServiceDetail @unmask
    }
  }
`);

export const SERVICE_WITH_CONFIGURATION_QUERY = gql(`
  query ServiceWithConfiguration($salonId: ID!, $serviceId: ID!) {
    serviceWithConfiguration(salonId: $salonId, serviceId: $serviceId) {
      ...ServiceDetail @unmask
    }
  }
`);

export const CALCULATE_SERVICE_PRICE_QUERY = gql(`
  query CalculateServicePrice($serviceId: ID!, $selectedOptions: [ID!]! = []) {
    calculateServicePrice(serviceId: $serviceId, selectedOptions: $selectedOptions) {
      ...PriceCalculation @unmask
    }
  }
`);

// Service pricing management mutations
export const UPDATE_SERVICE_PRICING_MUTATION = gql(`
  mutation UpdateServicePricing($salonId: ID!, $serviceId: ID!, $input: ServicePricingInput!) {
    updateServicePricing(salonId: $salonId, serviceId: $serviceId, input: $input) {
      ...ServiceDetail @unmask
    }
  }
`);

export const UPDATE_SERVICE_MUTATION = gql(`
  mutation UpdateService($salonId: ID!, $serviceId: ID!, $input: UpdateServiceInput!) {
    updateService(salonId: $salonId, serviceId: $serviceId, input: $input) {
      ...ServiceDetail @unmask
    }
  }
`);

// ServiceOptionGroup mutations
export const CREATE_SERVICE_OPTION_GROUP_MUTATION = gql(`
  mutation CreateServiceOptionGroup($salonId: ID!, $serviceId: ID!, $input: ServiceOptionGroupInput!) {
    createServiceOptionGroup(salonId: $salonId, serviceId: $serviceId, input: $input) {
      ...ServiceOptionGroup @unmask
    }
  }
`);

export const UPDATE_SERVICE_OPTION_GROUP_MUTATION = gql(`
  mutation UpdateServiceOptionGroup($salonId: ID!, $groupId: ID!, $input: UpdateServiceOptionGroupInput!) {
    updateServiceOptionGroup(salonId: $salonId, groupId: $groupId, input: $input) {
      ...ServiceOptionGroup @unmask
    }
  }
`);

export const REMOVE_SERVICE_OPTION_GROUP_MUTATION = gql(`
  mutation RemoveServiceOptionGroup($salonId: ID!, $groupId: ID!) {
    removeServiceOptionGroup(salonId: $salonId, groupId: $groupId)
  }
`);

export const ADD_SERVICE_OPTION_TO_GROUP_MUTATION = gql(`
  mutation AddServiceOptionToGroup($salonId: ID!, $groupId: ID!, $input: ServiceOptionInput!) {
    addServiceOptionToGroup(salonId: $salonId, groupId: $groupId, input: $input) {
      ...ServiceOption @unmask
    }
  }
`);

export const UPDATE_SERVICE_OPTION_MUTATION = gql(`
  mutation UpdateServiceOption($salonId: ID!, $optionId: ID!, $input: UpdateServiceOptionInput!) {
    updateServiceOption(salonId: $salonId, optionId: $optionId, input: $input) {
      ...ServiceOption @unmask
    }
  }
`);

export const REMOVE_SERVICE_OPTION_MUTATION = gql(`
  mutation RemoveServiceOption($salonId: ID!, $optionId: ID!) {
    removeServiceOption(salonId: $salonId, optionId: $optionId)
  }
`);

// Single atomic upsert mutation using UpsertService pattern (senior-level approach)
export const UPSERT_SERVICE_WITH_MATRIX_PRICING_MUTATION = gql(`
  mutation UpsertServiceWithMatrixPricing($salonId: ID!, $serviceId: ID!, $input: UpsertServiceWithMatrixPricingInput!) {
    upsertServiceWithMatrixPricing(salonId: $salonId, serviceId: $serviceId, input: $input) {
      ...ServiceDetail @unmask
    }
  }
`);

// Archived data queries
export const ARCHIVED_SERVICE_CATEGORIES_QUERY = gql(`
  query ArchivedServiceCategories($salonId: ID!) {
    archivedServiceCategories(salonId: $salonId) {
      ...ServiceCategory @unmask
      catalogId
      createdAt
      updatedAt
    }
  }
`);

export const ARCHIVED_SERVICES_QUERY = gql(`
  query ArchivedServices($salonId: ID!) {
    archivedServices(salonId: $salonId) {
      ...ServiceDetail @unmask
    }
  }
`);
